import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledStethoscopeGreenIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.50488 1.5C9.78103 1.5 10.0049 1.72386 10.0049 2V3.40039C10.0047 3.67635 9.78089 3.90039 9.50488 3.90039H7.49512C7.12701 3.90044 6.81344 4.24016 6.86719 4.65625L7.98633 11.8916L7.9873 11.9033C8.15171 13.1719 9.19853 14.0995 10.4141 14.0996H13.5859C14.8015 14.0995 15.8483 13.1719 16.0127 11.9033L16.0137 11.8916L17.1328 4.65625C17.1866 4.24016 16.873 3.90044 16.5049 3.90039H14.4951C14.2191 3.90039 13.9953 3.67635 13.9951 3.40039V2C13.9951 1.72386 14.219 1.5 14.4951 1.5H16.5049C18.3311 1.50005 19.7095 3.14811 19.4736 4.96973L19.4717 4.98242L18.3516 12.2285L18.3506 12.2275C18.0297 14.6629 16.0041 16.4999 13.5859 16.5H10.4141C7.99581 16.4999 5.96929 14.663 5.64844 12.2275V12.2285L4.52832 4.98242L4.52637 4.96973C4.29053 3.14811 5.66889 1.50005 7.49512 1.5H9.50488Z",
			stroke: "#00AF71",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 14.3351C12.6434 14.3351 13.165 14.8567 13.165 15.5001V19.5001C13.1651 19.9612 13.5389 20.3351 14 20.3351H18.5C19.1434 20.3351 19.665 20.8567 19.665 21.5001C19.665 22.1435 19.1434 22.6651 18.5 22.6652H14C12.252 22.6652 10.835 21.2481 10.835 19.5001V15.5001C10.835 14.8567 11.3566 14.3351 12 14.3351Z",
			fill: "white",
			stroke: "#00AF71"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18.5,
			cy: 21.5,
			r: 1.5,
			fill: "white",
			stroke: "#00AF71"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "path-4-outside-1_16756_3647",
			maskUnits: "userSpaceOnUse",
			x: 3.98035,
			y: 10.1016,
			width: 16,
			height: 7,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 3.98035,
				y: 10.1016,
				width: 16,
				height: 7
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.8571 12.1526L18.0196 11.1016H16.6421L16.5082 11.9676C16.3129 13.4745 15.0634 14.6 13.5857 14.6H10.4143C8.93651 14.6 7.68703 13.4745 7.49173 11.9676L7.35782 11.1016H5.98035L6.14287 12.1526C6.42832 14.3551 8.25448 16 10.4143 16H13.5857C15.7455 16 17.5716 14.3551 17.8571 12.1526Z"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.8571 12.1526L18.0196 11.1016H16.6421L16.5082 11.9676C16.3129 13.4745 15.0634 14.6 13.5857 14.6H10.4143C8.93651 14.6 7.68703 13.4745 7.49173 11.9676L7.35782 11.1016H5.98035L6.14287 12.1526C6.42832 14.3551 8.25448 16 10.4143 16H13.5857C15.7455 16 17.5716 14.3551 17.8571 12.1526Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0196 11.1016L19.0078 11.2544L19.1861 10.1016H18.0196V11.1016ZM17.8571 12.1526L16.8688 11.9998L16.8669 12.0119L16.8654 12.0241L17.8571 12.1526ZM16.6421 11.1016V10.1016H15.7849L15.6539 10.9487L16.6421 11.1016ZM16.5082 11.9676L15.52 11.8147L15.5181 11.8269L15.5165 11.839L16.5082 11.9676ZM7.49173 11.9676L8.48344 11.839L8.48186 11.8269L8.47998 11.8147L7.49173 11.9676ZM7.35782 11.1016L8.34607 10.9487L8.21506 10.1016H7.35782V11.1016ZM5.98035 11.1016V10.1016H4.81382L4.99209 11.2544L5.98035 11.1016ZM6.14287 12.1526L7.13458 12.0241L7.133 12.0119L7.13113 11.9998L6.14287 12.1526ZM18.0196 11.1016L17.0313 10.9487L16.8688 11.9998L17.8571 12.1526L18.8453 12.3054L19.0078 11.2544L18.0196 11.1016ZM16.6421 11.1016V12.1016H18.0196V11.1016V10.1016H16.6421V11.1016ZM16.5082 11.9676L17.4965 12.1204L17.6304 11.2544L16.6421 11.1016L15.6539 10.9487L15.52 11.8147L16.5082 11.9676ZM13.5857 14.6V15.6C15.5876 15.6 17.2428 14.0798 17.4999 12.0961L16.5082 11.9676L15.5165 11.839C15.383 12.8693 14.5392 13.6 13.5857 13.6V14.6ZM10.4143 14.6V15.6H13.5857V14.6V13.6H10.4143V14.6ZM7.49173 11.9676L6.50002 12.0961C6.75711 14.0798 8.41229 15.6 10.4143 15.6V14.6V13.6C9.46073 13.6 8.61696 12.8693 8.48344 11.839L7.49173 11.9676ZM7.35782 11.1016L6.36956 11.2544L6.50348 12.1204L7.49173 11.9676L8.47998 11.8147L8.34607 10.9487L7.35782 11.1016ZM5.98035 11.1016V12.1016H7.35782V11.1016V10.1016H5.98035V11.1016ZM6.14287 12.1526L7.13113 11.9998L6.9686 10.9487L5.98035 11.1016L4.99209 11.2544L5.15462 12.3054L6.14287 12.1526ZM10.4143 16V15C8.7787 15 7.35825 13.7499 7.13458 12.0241L6.14287 12.1526L5.15117 12.2811C5.49839 14.9603 7.73026 17 10.4143 17V16ZM13.5857 16V15H10.4143V16V17H13.5857V16ZM17.8571 12.1526L16.8654 12.0241C16.6417 13.7499 15.2212 15 13.5857 15V16V17C16.2697 17 18.5015 14.9603 18.8488 12.2811L17.8571 12.1526Z",
			fill: "#00AF71",
			mask: "url(#path-4-outside-1_16756_3647)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9.5,
			cy: 2.5,
			r: 1.5,
			fill: "white",
			stroke: "#00AF71"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14.5,
			cy: 2.5,
			r: 1.5,
			fill: "white",
			stroke: "#00AF71"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledStethoscopeGreenIcon);
const Memo = memo(ForwardRef);
export default Memo;
